// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> repli-sandbox-preferred -> jackstraw-apartments-db2e
// Generated: 2026-10-05T18:29:10.950Z
// Counts: 1 design, 30 content, 9 slot group, 4 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_bathrooms_range"
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "anyonehome-chatbot.account_id": {
    "overrideType": "VALUE",
    "customValue": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script> <script text='text/javascript'>window.OmniChannel.init('aGXht7qWqcp9t8JeCf')</script>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-blurb.text": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_applynow_blurb"
  },
  "contactus.form.opt_in_required": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "entrata-chatbot.embed_script": {
    "overrideType": "VALUE",
    "customValue": "<script type=\"text/javascript\" src=\"//commoncdn.entrata.com/javascript/i18n/i18n.min.js\"></script><script type=\"text/javascript\" src=\"//commoncdn.entrata.com/javascript/i18n/entrata-ui.min.js\"></script><script>!function(e){var t=document.createElement(\"script\"),n=function(){ppcb.render({subdomain:\"//apply.paseovillageapartments.com\",query:\"is_responsive_snippet=1&snippet_type=contact_button\"})};t.src=\"//commoncdn.entrata.com/website_templates/_assets/_common/contact_btn_controller.min.js?ver=1219288\",t.defer=!0,t.async=!0,t.readyState?t.onreadystatechange=function(){(\"loaded\"===t.readyState||\"complete\"===t.readyState)&&n()}:t.onload=n,document.head.appendChild(t)}(window);</script>",
    "generatedValue": null,
    "mappedField": null
  },
  "scrolltextsection.bg_image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde6-1b90-71fb-8f1c-0c5c59470866.webp",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "heading": {
        "type": "VALUE",
        "customValue": ""
      },
      "sub_label": {
        "type": "FIELD_MAPPING",
        "mappedField": ""
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "sub_label": {
        "type": "FIELD_MAPPING",
        "mappedField": ""
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449162938/019d4770-5ce7-70bb-b40f-5892d45e90a8.webp"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019f1a6f-8ca4-769c-9269-33596b1ac7e8.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex with blue and white buildings at sunset."
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019f19f4-5d7b-77e7-b20e-12ae06e62109.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Warm sunset over hay bales in a harvested field with golden straw and blue sky."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_c1538abac791fd5a4c4ccbb1"
    ],
    "orderedIds": [
      "ec_c1538abac791fd5a4c4ccbb1",
      "ec_a822033f8d489dcd75fe8e39",
      "ec_014d4e10f64e1a5d9cd33c95",
      "ec_6de340a0f68de53823692e17",
      "ec_5349bc0996103f88de9f1f4c",
      "ec_0df4e5a202d847383c34f5a2",
      "ec_68639e61542730be3cfe6104",
      "ec_9a04615a199fa1381107ddc4",
      "ec_23abb48827e2f541b5863d99",
      "ec_0966e32ca3b9b8024696c286",
      "ec_3423ccc771963bb3c9b9bb73",
      "ec_01e7e8ae9d9df98723d93054",
      "ec_d74ea0efe94ce86294c5a357",
      "ec_980c88c7805bbffc6ff8588f",
      "ec_749f0a5ffe170ba3462a6ccf",
      "ec_99195e5f5edbd8c6121d4e75"
    ],
    "hiddenIndices": [
      0
    ],
    "ordering": [
      0,
      2,
      1,
      3,
      4,
      6,
      7,
      5,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15
    ],
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "basis-tracking-pixel",
      "blockId": "basis-tracking-pixel",
      "position": 0
    },
    {
      "sectionId": "entrata-chatbot",
      "blockId": "entrata-chatbot",
      "position": 0
    }
  ],
  "contact": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 5
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
